module.exports = __webpack_public_path__ + "img/invest.4c2394c5.svg";